<template>
  <div class="plv-iar-product__empty">
    <icon-search-two
      v-if="isKeywordSearch"
      class="plv-iar-product__empty__icon pws-iar-product-list-empty-icon"
    />
    <div v-else class="plv-iar-product__empty__img pws-iar-product-list-empty-img"></div>
    <div class="plv-iar-product__empty__text pws-body-font-color3 pws-iar-product-list-empty-text">{{ tipText }}</div>
  </div>
</template>

<script>
import { IconSearchTwo } from '@/icon-components/map';
import basicMixin from '../../../assets/mixins/basic';

export default {
  mixins: [basicMixin],

  inject: ['productVm'],

  components: {
    IconSearchTwo,
  },

  props: {
    isKeywordSearch: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tipText() {
      if (this.isKeywordSearch) {
        return this.iarTrans('product.noSearch');
      }

      return this.iarTrans('product.noProduct');
    }
  },
};
</script>

<style lang="scss">
.plv-iar-product__empty {
  transform: translate(-50%, -50%);
  left: 50%;
  line-height: 18px;
  text-align: center;
  color: rgba(255, 255, 255, .3);
  font-size: 14px;
  position: absolute;
  top: 50%;
  padding: 0 10px;
  box-sizing: border-box;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.plv-iar-product__empty__img {
  width: 88px;
  height: 88px;
  margin-bottom: 8px;
  background-image: url(./imgs/empty.png);
  background-size: 100% 100%;
  opacity: 0.3;
}

.plv-iar-product__empty__icon {
  font-size: 70px;
  margin-bottom: 16px;
  display: flex;
}
</style>
